import {
    getCloudFrontImageUrl,
    getCloudFrontOriginalImageUrl,
} from "../../util/cloudFrontUtils";

export const PAID_CATEGORY_HEADINGS = {
    Audio: "Aufnahme & Mikrofone",
    Licht: "Licht",
    Effekte: "Effekte",
    Foto: "Foto",
};

export function paidCategoryHeading(category) {
    if (!category) return "Equipment";
    return PAID_CATEGORY_HEADINGS[category] || category;
}

/** Unique categories in order of first appearance. */
export function orderedCategoriesFromPaidItems(items) {
    const seen = new Set();
    const out = [];
    for (const raw of items) {
        const key = raw.category || "Sonstiges";
        if (!seen.has(key)) {
            seen.add(key);
            out.push(key);
        }
    }
    return out;
}

export function resolvePaidEquipmentImageSrc(item) {
    if (!item) return "";
    const rawUrl = item.imageUrl;
    if (typeof rawUrl === "string" && rawUrl) return rawUrl;
    if (rawUrl && typeof rawUrl === "object" && typeof rawUrl.default === "string") {
        return rawUrl.default;
    }
    const key =
        item.image?.key ||
        (typeof item.image === "string" ? item.image : null) ||
        item.imageKey;
    if (!key || typeof key !== "string") return "";
    try {
        if (/\.svg$/i.test(key)) {
            return getCloudFrontOriginalImageUrl(key);
        }
        return getCloudFrontImageUrl(key, { width: 400, height: 400, fit: "cover" });
    } catch {
        return "";
    }
}

export function formatPricePerPiece(price) {
    const n = typeof price === "number" ? price : parseFloat(String(price ?? "").replace(",", ".")) || 0;
    return `${n.toFixed(2)} € / Stück`;
}

export function groupPaidEquipmentByCategory(items) {
    const map = new Map();
    for (const item of items) {
        const key = item.category || "Sonstiges";
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(item);
    }
    return Array.from(map.entries());
}

/** Supports arrays or JSON string (e.g. AWSJSON) from the API. */
export function normalizePaidEquipmentInput(raw) {
    if (raw == null) return [];
    if (typeof raw === "string") {
        const t = raw.trim();
        if (!t) return [];
        try {
            const parsed = JSON.parse(t);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    return Array.isArray(raw) ? raw : [];
}
